import { THEME_TYPE } from '@interfaces';
import checkDeviceTheme from './checkDeviceTheme';


function checkTheme() {
    const activeTheme = (checkDeviceTheme() === THEME_TYPE.DARK) ? 'darkMode' : 'lightMode';
    return activeTheme;
}

export default checkTheme;